module.exports = __webpack_public_path__ + "assets/images/premium-features/templates-ed7d9f.png";